<template>
  <div>
    <small>{{ messageGreetings }}</small>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()

const client = useRuntimeConfig().public.client

const clientMap = useRuntimeConfig().public.clientMapping as ClientMapping

const messageGreetings = ref(t('dbc-text-greetings-from-us'))
messageGreetings.value = messageGreetings.value?.replace(
  '[placeholder]',
  clientMap[client]!
)
</script>
